export default __webpack_public_path__ + "static/media/IMG_0975.c7a329d8.gif";